import APIURL from "../axios";
import { useQuery } from "react-query";

const Orders = async (uuid, lang) => {
  return await APIURL.get(`/${uuid}/order/room-orders`, {
    headers: {
      Accept: "application/json",
      "Content-Type": "application/json",
      lang: lang,
    },
  });
};
export const ShowOrders = (uuid, lang) => {
  return useQuery(`Orders-${lang}`, () => Orders(uuid, lang), {
    refetchInterval: 5000,
  });
};
